import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { Dropdown } from 'semantic-ui-react';
import i18n from '../../i18n';
import spain from '../../images/spain.png';
import uk from '../../images/uk.png';
import fr from '../../images/francia.png';


class LanguageDropDownNoTransalation extends Component {
  static propTypes = {

  };

  changeLanguage = (language) => {
    switch (language) {
      case 'Español':
        i18n.changeLanguage('es');
        break;
      case 'English':
        i18n.changeLanguage('en');
        break;
      case 'Français':
        i18n.changeLanguage('fr');
        break;
      default:
        i18n.changeLanguage('es');
        break;
    }
  }
  languageClicked = (evt, data) => {
    const languageSelected = evt.target.innerHTML;
    this.changeLanguage(languageSelected)
  }

  render() {
    const { t } = this.props;

    const languageOptions = [
      { key: 'Spanish', text: 'Español', value: 'Spanish', image: { avatar: true, src: spain } },
      { key: 'English', text: 'English', value: 'English', image: { avatar: true, src: uk } },
      { key: 'French', text: 'Français', value: 'French', image: { avatar: true, src: fr } }
    ]

    return (
      <div className="common-language-drop-down">

        {/* <span> */}
        {/* {t('general.languageDropDown', { framework: 'React' })} */}
        <Dropdown
          inline
          options={languageOptions}
          defaultValue={languageOptions[0].value}
          onChange={this.languageClicked}
          direction='left'
        // pointing='top left'
        // button
        // className='icon'
        // floating
        // labeled
        // icon='world'
        // options={languageOptions}
        // search
        // text={t('general.languageDropDown', { framework: 'React' })}
        // onClick={this.languageClicked}
        />
        {/* </span> */}

      </div>
    );
  }
}

// {t('general.bookingButtonText', { framework: 'React' })}

const LanguageDropDown = withTranslation('common')(LanguageDropDownNoTransalation)

export default LanguageDropDown;


// WEBPACK FOOTER //
// ./src/features/common/LanguageDropDown.js